module.exports = __webpack_public_path__ + "img/big.be1a03fe.jpg";